import React, { useEffect, useState } from 'react';
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates_bus";
import { Bar } from 'react-chartjs-2';
// import CitySocChart from './CitySocChart';
// import './RangeAnalysis.css';
import moment from 'moment';
import ChartLoader_Bus from '../ChartLoader_Bus';
import NoDataDischarge from '../NoData/NoDataDischarge';
import WaterMark from '../WaterMark';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import CityRegChart from './CityRegChart';

export default function RangeRegAnalysis(props) {

  const { isLoading, error, sendReq: fetchData } = useHttp();

  const [gloablfilter, setGloablfilter] = useState(props.gloablfilter);
  const [monthLabel, setMonthLabel] = useState([]);
  const [monthData, setMonthData] = useState([]);
  const [clickedIndex, setClickedIndex] = useState(null);
  const [duration, setDuration] = useState("7D");
  const [sDate, setSDate] = useState();
  const [eDate, setEDate] = useState();
  const [TitleSelected, setTitleSelected] = useState('En_Reg');
  const [distSelected, setDistSelected] = useState("NetkWh");

  let apiprops = {};
  apiprops.startDate = gloablfilter.startDate
  apiprops.endDate = gloablfilter.endDate
  apiprops.city = gloablfilter.CITY
  apiprops.depo = gloablfilter.DEPO

  const enddate = moment().utc().format('YYYY-MM-DD[T]00:00:00.000[Z]')
  const startdate = moment().utc().subtract(7, 'days').startOf('day').format('YYYY-MM-DD[T]00:00:00.000[Z]');

  const handleDurationSelection = async (durationValue) => {
    await updateDates(durationValue);
  }

  const updateDates = async (durationValue) => {
    setDuration(durationValue);
    if (durationValue === "7D") {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(7, 'days').format('YYYY-MM-DD'));
    } else if (durationValue === '1M') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(31, 'days').format('YYYY-MM-DD'));
    } else if (durationValue === '3M') {
      setEDate(moment().format(('YYYY-MM-DD')));
      setSDate(moment().subtract(91, 'days').format('YYYY-MM-DD'));
    } else if (durationValue === '6M') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(183, 'days').format('YYYY-MM-DD'));
    } else if (durationValue === '1Y') {
      setEDate(moment().format('YYYY-MM-DD'));
      setSDate(moment().subtract(366, 'days').format('YYYY-MM-DD'));
    }
  }

  useEffect(() => {
    if (distSelected === 'NetkWh') {
      fetchData(
        {
          url: API_URL_MAIN + "trend_analysis_drive_bus/monthWiseRegTrend",
          body: {
            filterdata: {
              "CITY": apiprops.city,
              "DEPO": apiprops.depo,
              "LOB": [],
              "PL": [],
              "PPL": [],
              "SOC": 0,
              "VIN_NUM": [],
              "endDate": eDate ? eDate : enddate,
              // "endDate": "2023-10-22",
              "pageSelected": 1,
              "startDate": sDate ? sDate : startdate,
              // "startDate": "2023-10-15",
              "AIR_VENTILATION": "",
              "duration": duration
            }
          },
        },
        responceDataDate
      );
    } else {
      fetchData(
        {
          url: API_URL_MAIN + "trend_analysis_drive_bus/monthWiseRegPerKmTrend",
          body: {
            filterdata: {
              "CITY": apiprops.city,
              "DEPO": apiprops.depo,
              "LOB": [],
              "PL": [],
              "PPL": [],
              "SOC": 0,
              "VIN_NUM": [],
              "endDate": eDate ? eDate : enddate,
              // "endDate": "2023-10-22",
              "pageSelected": 1,
              "startDate": sDate ? sDate : startdate,
              // "startDate": "2023-10-15",
              "AIR_VENTILATION": "",
              "duration": duration
            }
          },
        },
        responceDataDate
      );
    }
  }, [gloablfilter, sDate, eDate, duration, distSelected]);

  const responceDataDate = (data) => {
    // if(distSelected === "NetkWh"){
    //     setMonthData(data.monthrangePerKm)
    // }else{
    //     setMonthData(data.monthrange)
    // }
    setMonthData(data.monthrangePerKm)
    setMonthLabel(data.monthname)

  }

  const colorPalette = ['#02559b', '#83a3ce', '#ced9e9', '#6081AA', '#3D6087', '#D4DFEB', '#184165', '#002446', '#1E618E', '#53749D', '#AFCFFC', '#949BE6',];

  let datasets = [];

  if (monthLabel && monthData.length > 0) {
    datasets = [{
      label: '',
      data: monthData,
      backgroundColor: colorPalette.slice(0, monthData.length),
      borderColor: '#494F55',
      borderWidth: 1,
      barThickness: 40,
    }];
  }

  const data = {
    labels: monthLabel,
    datasets,
  };

  const options = {
    scales: {
      x: {
        barPercentage: 0.2, // Adjust the value to decrease or increase the gap between bars
        categoryPercentage: 0.2,// Adjust the value to decrease or increase the gap between bars
      },
      y: {
        beginAtZero: true
      }
    },
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        color: '#fff', // color of the data labels
        anchor: 'end', // position of the data labels
        align: 'start', // alignment of the data labels
        // rotation: 270,
        font: {
          weight: 'bold', // make the text bold
        },
        formatter: function (value, context) {
          return value.toFixed(3); // format how the data labels appear
        }
      },
    },
    elements: {
      line: {
        tension: 0,
      },
    },
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 0,
        bottom: 0,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const clickedElementIndex = elements[0].index;
        const clickedDataValue = data.datasets[0].data[clickedElementIndex];
        const clickedLabel = data.labels[clickedElementIndex];
        setClickedIndex(clickedElementIndex);
      }
    },
  };

  const resetfunc = (dur) => {
    handleDurationSelection(dur)
    setClickedIndex(null);
  }

  const changeTitle = (selectTitle) => {
    setTitleSelected(selectTitle);
    props.onreset(selectTitle)
  }

  const changedistTrigger = (topup) => {
    setDistSelected(topup)
  }


  return (
    <>
      <div className='container-fluid mt-3'>
        <div className='row' style={{ backgroundColor: "#fff", boxShadow: "0px 3px 6px #00000027", borderRadius: "7px" }}>
          <WaterMark style={{ marginTop: "100px" }} />
          <div className={clickedIndex === null ? 'row mt-1 mb-2 discharge_titlebg_bus_trend' : 'row d-none mt-1 mb-2 discharge_titlebg_bus_trend'}>
            {/* <div className="col-md-7 "> */}
            <div className={TitleSelected === 'SOC' ? "col-md-7 mt-1" : "col-md-5 pt-1"} style={{ margin: "0px", padding: "0px" }}>
              <div className="text-fit">
                <select className="form-select form-select-sm" aria-label=".form-select-sm example" style={{ marginBottom: "-5px", marginTop: "-5px" }} onChange={(event) => changeTitle(event.target.value)} value={TitleSelected}>
                  <option value="SOC">Discharge Soc(%) Analysis</option>
                  <option value="En_Reg">Regeneration Analysis</option>
                </select>
              </div>
            </div>
            <div className="col-md-5 py-1">
              <div className="mt-1" style={{ border: "1px solid #b7c0ca", padding: "3px", borderRadius: "5px", float: "right" }}>
                <ul className="nav nav-tabs" role="tablist" style={{ marginBottom: "5px", border: "0px" }}>
                  <li className="nav-item" style={{ width: "40px" }}>
                    <a
                      style={{ justifyContent: "center", backgroundColor: duration === "7D" ? "#f2f2f2" : "transparent", color: duration === "7D" ? "#fff" : "#000" }}
                      className={(duration === "7D") ? "nav-link active py-0" : "nav-link py-0"}
                      data-bs-toggle="tab"
                      href="#day"
                      id="7D"
                      onClick={() => handleDurationSelection("7D")}
                    >
                      7D
                    </a>
                  </li>
                  <li className="nav-item" style={{ width: "40px" }}>
                    <a
                      style={{ justifyContent: "center", backgroundColor: duration === "1M" ? "#f2f2f2" : "transparent", color: duration === "1M" ? "#fff" : "#000" }}
                      className={(duration === "1M") ? "nav-link active py-0" : "nav-link py-0"}
                      data-bs-toggle="tab"
                      href="#mon"
                      onClick={() => handleDurationSelection("1M")}
                    >
                      1M
                    </a>
                  </li>
                  <li className="nav-item" style={{ width: "40px" }}>
                    <a
                      style={{ justifyContent: "center", backgroundColor: duration === "3M" ? "#f2f2f2" : "transparent", color: duration === "3M" ? "#fff" : "#000" }}
                      className={(duration === "3M") ? "nav-link active py-0" : "nav-link py-0"}
                      data-bs-toggle="tab"
                      href="#mon"
                      onClick={() => handleDurationSelection("3M")}
                    >
                      3M
                    </a>
                  </li>
                  <li className="nav-item" style={{ width: "40px" }}>
                    <a
                      style={{ justifyContent: "center", backgroundColor: duration === "6M" ? "#f2f2f2" : "transparent", color: duration === "6M" ? "#fff" : "#000" }}
                      className={(duration === "6M") ? "nav-link active py-0" : "nav-link py-0"}
                      data-bs-toggle="tab"
                      href="#mon"
                      onClick={() => handleDurationSelection("6M")}
                    >
                      6M
                    </a>
                  </li>
                  <li className="nav-item" style={{ width: "40px" }}>
                    <a
                      style={{ justifyContent: "center", backgroundColor: duration === "1Y" ? "#f2f2f2" : "transparent", color: duration === "1Y" ? "#fff" : "#000" }}
                      className={(duration === "1Y") ? "nav-link active py-0" : "nav-link py-0"}
                      data-bs-toggle="tab"
                      href="#year"
                      onClick={() => handleDurationSelection("1Y")}
                    >
                      1Y
                    </a>
                  </li>
                </ul>
              </div>
            </div>


            {(TitleSelected === "En_Reg") &&
              <div className='col-md-2 py-2' style={{ margin: "0px", padding: "0px" }}>
                <select
                  className="form-select form-select-sm"
                  aria-label="Default select example"
                  onChange={(event) => changedistTrigger(event.target.value)}
                  value={distSelected}
                >
                  <option value="NetkWh">kWh</option>
                  <option value="whPerKM">kWh/km</option>
                </select>
              </div>
            }
          </div>

          <div>
            {(clickedIndex !== null) ? <CityRegChart index={clickedIndex} apiprops={apiprops} monthLabel={monthLabel} duration={duration} gloablfilter={gloablfilter} onreset={resetfunc} distSelected={distSelected} />
              :
              (isLoading) ? <ChartLoader_Bus /> :
                (monthData.length === 0) ? <NoDataDischarge /> :
                  (
                    <Bar data={data} options={options} type={'bar'} style={{ height: "238px", width: "250px" }} plugins={[ChartDataLabels]} />
                  )
            }
          </div>
        </div>
      </div>
    </>
  )
}

